module.exports = __webpack_public_path__ + "static/img/anonymity.3f9b695.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ratings/img/anonymity.png
// module id = Qvfx
// module chunks = 0